import { render } from "./Doc.vue?vue&type=template&id=5ee31956&scoped=true"
import script from "./Doc.vue?vue&type=script&lang=js"
export * from "./Doc.vue?vue&type=script&lang=js"

import "./Doc.vue?vue&type=style&index=0&id=5ee31956&lang=scss&scoped=true"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee31956"]])

export default __exports__